import { Card, LabelValueRow, Tabs } from 'components/core-v2'

export const Loading = () => (
  <Tabs.Panel value="strategy">
    <Card.Wrapper>
      <LabelValueRow isLoading />
      <LabelValueRow isLoading />
      <LabelValueRow isLoading />
      <LabelValueRow isLoading />
    </Card.Wrapper>
  </Tabs.Panel>
)
